<template>
  <div>
    <li class="w-full px-4 py-3 border-gray-200 rounded-t-lg" :class="{ 'border-b': showBottomBorder }">
      <slot />
    </li>
  </div>
</template>
<script>
export default {
  props: {
    showBottomBorder: {
      type: Boolean,
      default: true,
    },
  },
};
</script>
